import React from "react";

const koulen = { fontFamily: "Koulen, sans-serif" };

// `labels` overrides the text for a value; without it the value itself is
// shown. Labels are uppercased in the DOM (not CSS) so accessible names and
// tests see the visible text. `ariaLabel` names the group, which is what keeps
// the status and source rows apart when both contain an "ALL" tab.
export default function FilterTabs({ filters, value, onChange, labels, ariaLabel }) {
    return (
        <div role="group" aria-label={ariaLabel} className="flex flex-wrap gap-x-[28px] gap-y-2">
            {filters.map((filter) => (
                <button
                    key={filter}
                    type="button"
                    onClick={() => onChange(filter)}
                    className={`pb-[4px] text-[20px] sm:text-[24px] tracking-[1.5px] border-b-[3px] ${
                        value === filter
                            ? "text-[#1c2938] border-[#1c2938]"
                            : "text-[#777f88] border-transparent"
                    }`}
                    style={koulen}
                >
                    {(labels?.[filter] ?? filter.replace(/-/g, " ")).toUpperCase()}
                </button>
            ))}
        </div>
    );
}
